import { useContext } from "react";
import { SiteContext, SiteProviderAPI } from "./SiteProvider";

const useSiteContext = (): SiteProviderAPI => useContext(SiteContext);

export { useSiteContext };
